module.exports = __webpack_public_path__ + "img/NO885621252.922a3b97.png";